
















import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  handleRedirectToStore,
  refuseOpenInApp,
  shouldPromptOpenInApp
} from '@/helpers/OpenInApp'

@Component
export default class OpenInAppConfirm extends Vue {
  @Prop({ required: true }) private id!: string

  private confirmedByYes = false

  mounted() {
    if (shouldPromptOpenInApp(this.$route.query.redirectToApp)) {
      this.$bvModal.show(this.id)
    }
  }

  onConfirm() {
    this.confirmedByYes = true
    handleRedirectToStore()
    this.$bvModal.hide(this.id)
  }

  onDismiss() {
    this.$bvModal.hide(this.id)
  }

  onHidden() {
    if (this.confirmedByYes) {
      // Stay on current URL; castgram:// attempt runs without navigation.
      this.confirmedByYes = false
      return
    }
    refuseOpenInApp()
  }
}
